    (function(w,t,c,p,s,e,l,k){
        p=new Promise(function(r){w[c]={client:function(){return p}};
            l=document.createElement('div');l.setAttribute("id", "live-caller-widget");
            s=document.createElement(t);s.async=1;s.setAttribute("data-livecaller", 'script');
            k=document.body || document.documentElement;k.insertBefore(l, k.firstChild);
            l.setAttribute("data-livecaller", 'mount-el');s.src='https://cdn.livecaller.io/js/app.js';
            e=document.getElementsByTagName(t)[0];e ? e.parentNode.insertBefore(s,e) : k.insertBefore(s, l.nextSibling);
            s.onload=function(){r(w[c]);};});return p;
    })(window,'script','LiveCaller').then(function(){
        try{
            var liveCallerLocale = (function () {
                var path = (window.location.pathname || '').replace(/^\/+/, '');
                if (!path.length) {
                    return 'ka';
                }
                var firstSegment = path.split('/')[0];
                if (firstSegment && /^[a-z]{2}(?:-[a-z]{2})?$/i.test(firstSegment)) {
                    return firstSegment.toLowerCase();
                }
                return 'ka';
            })();

            LiveCaller.config.merge({"widget":{"id":"8dffad1b-de7c-4fa6-8e92-3152d37789db"},"app":{"locale":liveCallerLocale}});
            LiveCaller.liftOff();
            LiveCaller.config.merge({app:{locale:liveCallerLocale}});
            LiveCaller.$emit('app.locale.update', liveCallerLocale);

            (function(){
                var body=document.body;
                if(!body){
                    return;
                }
                var hasModalState=function(){
                    return body.classList.contains('has-modal-open') || body.classList.contains('has-modal-opening');
                };
                var closeWidgetIfNeeded=function(force){
                    if(force || hasModalState()){
                        LiveCaller.$emit('ui.widget.close');
                    }
                };
                var previousState=hasModalState();
                if(previousState){
                    closeWidgetIfNeeded(true);
                }
                var observer=new MutationObserver(function(){
                    var currentState=hasModalState();
                    if(currentState && !previousState){
                        closeWidgetIfNeeded();
                    }
                    previousState=currentState;
                });
                observer.observe(body,{attributes:true,attributeFilter:['class']});
            })();
        }catch(e){
        }
    });
